import { useQueryCacheAndNetwork } from '@/hooks/useQueryCacheAndNetwork';
import { FetchMyBookmarksQuery, FetchMyBookmarksQueryVariables, QUERY_MY_BOOKMARKS } from '@edwin-group/cj-graphql';

export function useBookmark<T>(filters: FetchMyBookmarksQueryVariables) {
  const { data, refetch } = useQueryCacheAndNetwork<FetchMyBookmarksQuery, FetchMyBookmarksQueryVariables>(
    QUERY_MY_BOOKMARKS,
    {
      variables: {
        relationId: filters.relationId,
        category: filters.category,
        resourceType: filters.resourceType,
      },
    },
  );

  return {
    data: data?.fetchMyBookmarks?.results?.map((result) => result?.metadata as T),
    refetch,
  };
}
